import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[nrTemplate]',
})
export class NisloTemplateDirective {
  @Input() type: string;

  @Input('nrTemplate') name: string;

  constructor(public template: TemplateRef<any>) {}

  getType(): string {
    return this.name;
  }
}
